const enableScroll = () => {
	document.body.style.position = "";
	document.body.style.top = "";
	document.body.style.left = "";
	document.body.style.right = "";

	setTimeout(() => {
		document.documentElement.style.scrollBehavior = "smooth";
	}, 300);
};

export default enableScroll;



// WEBPACK FOOTER //
// ./scripts/modules/enable-scroll.js